export const timeOptions = [
  { label: "12:00 AM", value: "12:00 AM" },
  { label: "12:30 AM", value: "12:30 AM" },
  { label: "01:00 AM", value: "01:00 AM" },
  { label: "01:30 AM", value: "01:30 AM" },
  { label: "02:00 AM", value: "02:00 AM" },
  { label: "02:30 AM", value: "02:30 AM" },
  { label: "03:00 AM", value: "03:00 AM" },
  { label: "03:30 AM", value: "03:30 AM" },
  { label: "04:00 AM", value: "04:00 AM" },
  { label: "04:30 AM", value: "04:30 AM" },
  { label: "05:00 AM", value: "05:00 AM" },
  { label: "05:30 AM", value: "05:30 AM" },
  { label: "06:00 AM", value: "06:00 AM" },
  { label: "06:30 AM", value: "06:30 AM" },
  { label: "07:00 AM", value: "07:00 AM" },
  { label: "07:30 AM", value: "07:30 AM" },
  { label: "08:00 AM", value: "08:00 AM" },
  { label: "08:30 AM", value: "08:30 AM" },
  { label: "09:00 AM", value: "09:00 AM" },
  { label: "09:30 AM", value: "09:30 AM" },
  { label: "10:00 AM", value: "10:00 AM" },
  { label: "10:30 AM", value: "10:30 AM" },
  { label: "11:00 AM", value: "11:00 AM" },
  { label: "11:30 AM", value: "11:30 AM" },
  { label: "12:00 PM", value: "12:00 PM" },
  { label: "12:30 PM", value: "12:30 PM" },
  { label: "01:00 PM", value: "01:00 PM" },
  { label: "01:30 PM", value: "01:30 PM" },
  { label: "02:00 PM", value: "02:00 PM" },
  { label: "02:30 PM", value: "02:30 PM" },
  { label: "03:00 PM", value: "03:00 PM" },
  { label: "03:30 PM", value: "03:30 PM" },
  { label: "04:00 PM", value: "04:00 PM" },
  { label: "04:30 PM", value: "04:30 PM" },
  { label: "05:00 PM", value: "05:00 PM" },
  { label: "05:30 PM", value: "05:30 PM" },
  { label: "06:00 PM", value: "6:00 PM" },
  { label: "06:30 PM", value: "06:30 PM" },
  { label: "07:00 PM", value: "07:00 PM" },
  { label: "07:30 PM", value: "07:30 PM" },
  { label: "08:00 PM", value: "08:00 PM" },
  { label: "08:30 PM", value: "08:30 PM" },
  { label: "09:00 PM", value: "09:00 PM" },
  { label: "09:30 PM", value: "09:30 PM" },
  { label: "10:00 PM", value: "10:00 PM" },
  { label: "10:30 PM", value: "10:30 PM" },
  { label: "11:00 PM", value: "11:00 PM" },
  { label: "11:30 PM", value: "11:30 PM" },
];

// East Perth & Crown Plaza: 8:00 AM - 5:00 PM only
// Perth Airport: all time slots (full range)
export const officeHoursTimeOptions = [
  { label: "08:00 AM", value: "08:00 AM" },
  { label: "08:30 AM", value: "08:30 AM" },
  { label: "09:00 AM", value: "09:00 AM" },
  { label: "09:30 AM", value: "09:30 AM" },
  { label: "10:00 AM", value: "10:00 AM" },
  { label: "10:30 AM", value: "10:30 AM" },
  { label: "11:00 AM", value: "11:00 AM" },
  { label: "11:30 AM", value: "11:30 AM" },
  { label: "12:00 PM", value: "12:00 PM" },
  { label: "12:30 PM", value: "12:30 PM" },
  { label: "01:00 PM", value: "01:00 PM" },
  { label: "01:30 PM", value: "01:30 PM" },
  { label: "02:00 PM", value: "02:00 PM" },
  { label: "02:30 PM", value: "02:30 PM" },
  { label: "03:00 PM", value: "03:00 PM" },
  { label: "03:30 PM", value: "03:30 PM" },
  { label: "04:00 PM", value: "04:00 PM" },
  { label: "04:30 PM", value: "04:30 PM" },
  { label: "05:00 PM", value: "05:00 PM" },
];

// Helper: get appropriate time options for PICKUP based on selected location
// East Perth & Crown Plaza: 8am-5pm only for pickup
// Perth Airport: full 24hr
export const getTimeOptionsForLocation = (location) => {
  if (!location || location === "Perth Airport") {
    return timeOptions; // Full 24hr range for airport
  }
  // East Perth and Crown Plaza get office hours only for PICKUP
  return officeHoursTimeOptions;
};

// Helper: get time options for DROP-OFF - always full 24hr range regardless of location
export const getDropoffTimeOptions = () => {
  return timeOptions;
};

// Helper: Get the correct default pickup time for a location
// Perth Airport: current Perth time (rounded)
// East Perth / Crown Plaza: current Perth time if within 8am-5pm, otherwise 08:00 AM
export const getDefaultPickupTimeForLocation = (location) => {
  if (location === "Perth Airport") {
    return getCurrentPerthTimeRounded();
  }
  // For East Perth / Crown Plaza, use current Perth time if within office hours
  const now = new Date();
  const perthTimeStr = now.toLocaleString("en-US", { timeZone: "Australia/Perth" });
  const perthTime = new Date(perthTimeStr);
  const currentHour = perthTime.getHours();
  
  // If current time is within office hours (8am-5pm), use rounded current time
  if (currentHour >= 8 && currentHour < 17) {
    const rounded = getCurrentPerthTimeRounded();
    // Verify the rounded time is still within office hours
    const validTimes = officeHoursTimeOptions.map(t => t.value);
    if (validTimes.includes(rounded)) {
      return rounded;
    }
  }
  // Otherwise default to 08:00 AM
  return "08:00 AM";
};

// Helper: Get current Perth time rounded up to next 30-min slot, formatted as "hh:mm AM/PM"
export const getCurrentPerthTimeRounded = () => {
  const now = new Date();
  const perthTimeStr = now.toLocaleString("en-US", { timeZone: "Australia/Perth" });
  const perthTime = new Date(perthTimeStr);
  
  let hours = perthTime.getHours();
  let minutes = perthTime.getMinutes();
  
  // Round up to next 30-min slot
  if (minutes > 30) {
    hours += 1;
    minutes = 0;
  } else if (minutes > 0) {
    minutes = 30;
  }
  
  // Handle overflow past midnight
  if (hours >= 24) {
    hours = 0;
  }
  
  // Format as 12-hour with AM/PM
  const period = hours >= 12 ? "PM" : "AM";
  const displayHour = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
  const formatted = `${String(displayHour).padStart(2, "0")}:${String(minutes).padStart(2, "0")} ${period}`;
  return formatted;
};

// Helper: Get current date in Perth timezone as YYYY-MM-DD
export const getPerthDateToday = () => {
  const now = new Date();
  // Get Perth date parts directly to avoid timezone conversion issues
  const perthOptions = { timeZone: "Australia/Perth", year: "numeric", month: "2-digit", day: "2-digit" };
  const perthParts = new Intl.DateTimeFormat("en-CA", perthOptions).format(now); // en-CA gives YYYY-MM-DD
  return perthParts;
};

// Helper: Get Perth date for tomorrow as YYYY-MM-DD
export const getPerthDateTomorrow = () => {
  const now = new Date();
  const tomorrow = new Date(now.getTime() + 24 * 60 * 60 * 1000);
  const perthOptions = { timeZone: "Australia/Perth", year: "numeric", month: "2-digit", day: "2-digit" };
  const perthParts = new Intl.DateTimeFormat("en-CA", perthOptions).format(tomorrow);
  return perthParts;
};

// Helper: Check if current Perth time is past office hours (5 PM)
// Perth timezone is Australia/Perth (UTC+8)
export const isPerthOfficeHoursPassed = () => {
  // Get current time in Perth timezone
  const now = new Date();
  const perthTimeStr = now.toLocaleString("en-US", { timeZone: "Australia/Perth" });
  const perthTime = new Date(perthTimeStr);
  const currentHour = perthTime.getHours();
  // Office hours end at 5 PM (17:00)
  return currentHour >= 17;
};

// Helper: Check if current Perth time is before office hours start (8 AM)
export const isPerthBeforeOfficeHours = () => {
  const now = new Date();
  const perthTimeStr = now.toLocaleString("en-US", { timeZone: "Australia/Perth" });
  const perthTime = new Date(perthTimeStr);
  const currentHour = perthTime.getHours();
  // Office hours start at 8 AM
  return currentHour < 8;
};

// Helper: Get the correct pickup date for a location based on Perth time
// For East Perth & Crown Plaza: if current Perth time is past 5 PM, bump to tomorrow
// For Perth Airport: always Perth's today (24/7 operation)
export const getDefaultPickupDateForLocation = (location) => {
  if (location === "Perth Airport") {
    return getPerthDateToday();
  }
  // For East Perth and Crown Plaza, check if office hours have passed
  if (isPerthOfficeHoursPassed()) {
    return getPerthDateTomorrow();
  }
  return getPerthDateToday();
};

// Helper: format a Date object as YYYY-MM-DD
const formatDateYMD = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
export const driverAge = [
  { label: "21", value: "21" },
  { label: "22", value: "22" },
  { label: "23", value: "22" },
  { label: "24", value: "22" },
  { label: "25", value: "22" },
  { label: "26", value: "22" },
  { label: "27", value: "22" },
  { label: "28", value: "22" },
  { label: "29", value: "22" },
  { label: "30+", value: "30" },
  
];
